import { config } from 'client/hooks/config';
import type * as api from 'common/types/api';
import { Api } from 'common/utils/api';
import { useMutation } from 'react-query';

type Response = api.UserFacilityResponse;

export interface UserFacilityUpdateRequest {
    userId: string;
    facilities: number[];
}

export const useUpsertUserFacilities = () => {
    const { path: updatePath } = config.user.updateFacilities();
    const updateMuation = useMutation((data: UserFacilityUpdateRequest) => Api.post<Response>({ path: updatePath, body: data }));
    return {
        updateUserFacilities: updateMuation.mutateAsync,
    };
};
